import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface PaymentState {
  merchant: any;
  payment: any;
  customer: any;
}

const initialState: PaymentState = {
  merchant: null,
  payment: null,
  customer: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetState: () => initialState,
    loadState: (state, action: PayloadAction<PaymentState>) => {
      state.merchant = action.payload.merchant;
      state.payment = action.payload.payment;
      state.customer = action.payload.customer || null;
    },
  },
});

export const { resetState, loadState } = paymentSlice.actions;
export default paymentSlice.reducer;
